import React, { useEffect, useState } from "react";
import NavBar from "../../communs/NavBar";
import { Col, Form, Row } from "antd";
import Inputs from "../../../biblio/Inputs/Inputs";
import Selects from "../../../biblio/Selects/Selects";
import SecondaryButton from "../../../biblio/Buttons/SecondaryButton";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../apis/store";
import {
  toAddSponsor,
  toGetAllBanks,
  toGetAllContactMethods,
  toGetAllContactTime,
} from "../../../apis/actions/sponsor.actions";
import { showNotitfication } from "../../../components/utils/utils";
import OtpModal from "../../../components/otpModal/OtpModal";

const AddSponsor = () => {
  const dispatch = useDispatch<AppDispatch>();
  const [form] = Form.useForm();
  const { contact_methods, banks, loading } = useSelector(
    (state: RootState) => state.sponsor
  );
  const [isModalVisible, setIsModalVisible] = useState<boolean>(false);
  const [sponsorId, setSponsorId] = useState<number>(0);
  const [, setIsRequired] = useState<boolean>(false);

  const handleCloseOtpModal = () => {
    setIsModalVisible(false);
  };

  useEffect(() => {
    dispatch(toGetAllContactMethods());
    dispatch(toGetAllContactTime());
    dispatch(toGetAllBanks());
  }, [dispatch]);

  const onFinish = async () => {
    try {
      await form.validateFields();

      const contactMethodIds = form
        .getFieldValue("contact_method_ids")
        ?.map((method: any) => method.value);

      const bankId = form.getFieldValue("bank_id")?.value;

      const gender = form.getFieldValue("gender");
      const mappedGender = gender.value === 1 ? "male" : "female";
      const sponsorRepresentativeGender = form.getFieldValue(
        "sponsor_representative_gender"
      )
        ? form.getFieldValue("sponsor_representative_gender").value === 1
          ? "male"
          : form.getFieldValue("sponsor_representative_gender").value === 2
          ? "female"
          : ""
        : "";
      const otherFormValues = form.getFieldsValue();
      const sponsorFormData = {
        ...otherFormValues,
        contact_method_ids: contactMethodIds,
        bank_id: bankId,
        gender: mappedGender,
        sponsor_representative_gender: sponsorRepresentativeGender,
      };
      const success = (await dispatch(toAddSponsor(sponsorFormData))) as any;
      const sponsor = success?.payload?.data?.result;

      if (sponsor?.code === 200) {
        showNotitfication(sponsor?.message, "success");
        setSponsorId(sponsor?.sponsor_request_id);
        setTimeout(() => {
          setIsModalVisible(true);
        }, 3000);
      } else {
        showNotitfication(sponsor?.message, "error");
      }
    } catch (error) {}
  };

  const onChange = () => {
    const fields = [
      "sponsor_representative_firstname",
      "sponsor_representative_father_name",
      "sponsor_representative_grandfather_name",
      "sponsor_representative_family_name",
      "sponsor_representative_gender",
      "sponsor_representative_phone",
    ];

    const anyFieldFilled = fields.some((field) => form.getFieldValue(field));
    setIsRequired(anyFieldFilled);
  };

  return (
    <>
      <NavBar variant="homePage" />
      <div className="takaful--add-recipient takaful--sponsor-container">
        <div className="takaful--add-recipient-title-image takaful--sponsor-image">
          <div className="takaful--title-tabs takaful--sponsor-title">
            <span>طلب كفالة</span>
            <p>
              نسعد بانضمامك لنا لنشاركك فرحة الكفالة ولتبقى على اطلاع بكافة
              التفاصيل الخاصة بحسابك و مساهماتك
            </p>
          </div>
        </div>
        <Form form={form} layout="vertical" onChange={onChange}>
          <Row gutter={16} dir="rtl" className="takaful--sponsor-sub-title">
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <span className="takaful--title-tabs-sub">بيانات الكافل</span>
            </Col>
          </Row>
          <Row
            gutter={16}
            dir="rtl"
            style={{
              paddingTop: "2rem",
              paddingRight: "2rem",
              paddingLeft: "2rem",
            }}
          >
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="firstname"
                label="الاسم الأول"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                className="takaful--label-inputs"
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="father_name"
                label="إسم الأب"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="grandfather_name"
                label="إسم الجد"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="family_name"
                label="إسم العائلة"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="gender"
                label="الجنس"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Selects
                  options={[
                    { id: 1, name: "ذكر" },
                    { id: 2, name: "أنثى" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="mobile"
                label="رقم الجوال"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                  {
                    len: 10,
                    message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs placeholder="05XXXXXXXX" type="tel" maxLength={10} />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="email"
                label="البريد الإلكتروني"
                labelCol={{ className: "takaful--label-style" }}
                rules={[
                  {
                    type: "email",
                    message:
                      "يجب  التأكد من أن البريد الإلكتروني مكتوب بشكل صحيح",
                  },
                ]}
              >
                <Inputs placeholder="email@example.com" type="email" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="contact_method_ids"
                label="طرق التواصل"
                labelCol={{ className: "takaful--label-style" }}
              >
                <Selects
                  options={contact_methods}
                  mode="multiple"
                  className="takaful--select-multiple"
                />
              </Form.Item>
            </Col>

            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="address"
                label="العنوان"
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="bank_id"
                label="البنك"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Selects options={banks} />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="account_number"
                label="رقم الحساب"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="tel" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="account_owner"
                label="صاحب الحساب"
                rules={[
                  {
                    required: true,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
          </Row>
          {/* REQUESTED BY THE CLIENT: hide "بيانات الوكيل" (agent/representative) section */}
          {/*
          <Row gutter={16} dir="rtl" className="takaful--sponsor-sub-title">
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <span className="takaful--title-tabs-sub">بيانات الوكيل</span>
            </Col>
          </Row>
          <Row gutter={16} dir="rtl" style={{ padding: "2rem" }}>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="sponsor_representative_firstname"
                label="الإسم الأول"
                rules={[
                  {
                    required: isRequired,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="sponsor_representative_father_name"
                label="إسم الأب"
                rules={[
                  {
                    required: isRequired,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="sponsor_representative_grandfather_name"
                label="إسم الجد"
                rules={[
                  {
                    required: isRequired,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="sponsor_representative_family_name"
                label="إسم العائلة"
                rules={[
                  {
                    required: isRequired,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs type="text" />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="sponsor_representative_gender"
                label="الجنس"
                rules={[
                  {
                    required: isRequired,
                    message: "الرجاء تعبئة الحقل",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Selects
                  options={[
                    { id: 1, name: "ذكر" },
                    { id: 2, name: "أنثى" },
                  ]}
                />
              </Form.Item>
            </Col>
            <Col xxl={6} xl={6} lg={12} md={12} sm={24} xs={24}>
              <Form.Item
                name="sponsor_representative_phone"
                label="رقم الجوال"
                rules={[
                  {
                    required: isRequired,
                    message: "الرجاء تعبئة الحقل",
                  },
                  {
                    len: 10,
                    message: "يجب أن يتكون رقم الهاتف من 10 ارقام",
                  },
                ]}
                labelCol={{ className: "takaful--label-style" }}
              >
                <Inputs placeholder="05XXXXXXXX" type="tel" maxLength={10} />
              </Form.Item>
            </Col>
          </Row>
          */}
        </Form>

        <div className="takaful--sponsor-secondary-button">
          <SecondaryButton
            title="تسجيل"
            onClick={onFinish}
            loading={loading}
            disabled={loading}
          />
        </div>

        <OtpModal
          open={isModalVisible}
          onClose={handleCloseOtpModal}
          recordId={sponsorId}
          model="sponsor"
          mobile={
            form.getFieldValue("sponsor_representative_phone")
              ? form.getFieldValue("sponsor_representative_phone")
              : form.getFieldValue("mobile")
          }
        />
      </div>
    </>
  );
};

export default AddSponsor;
